module.exports = __webpack_public_path__ + "img/翼首草.b681d77c.jpg";